import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-model-icon10",
  "use": "icon-model-icon10-usage",
  "viewBox": "0 0 16 14",
  "content": "<symbol viewBox=\"0 0 16 14\" fill=\"\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-model-icon10\">\n<path id=\"icon-model-icon10_Vector\" d=\"M0 6.51163H16V7.48837H0V6.51163ZM0 0H1.53846V0.976744H0V0ZM11.8769 0.976744H9.29231V0H11.8769V0.976744ZM6.70769 0.976744H4.12308V0H6.70769V0.976744ZM14.4615 0H16V0.976744H14.4615V0ZM0 13.0233H1.53846V14H0V13.0233ZM11.8769 14H9.29231V13.0233H11.8769V14ZM6.70769 14H4.12308V13.0233H6.70769V14ZM14.4615 13.0233H16V14H14.4615V13.0233Z\" fill=\"\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol